<template>
  <div v-if="loading" class="loading">Aguarde ...</div>
  <div v-else class="container">
    <div class="text-left">
      <h3>
        <router-link to="/usuarios">Usuários</router-link> » <router-link to="/usuario/0">Adicionar</router-link>
      </h3>
    </div>
    <table>
      <tr>
        <td></td>
        <td></td>
        <td>nome</td>
      </tr>
      <tr v-for="user in users">
        <td><a @click.prevent="select4edit(user.cod)" class="glyphicon glyphicon-pencil" title="Editar"></a></td>
        <td><a @click.prevent="select4agenda(user.cod)" class="glyphicon glyphicon-book" title="Agenda"></a></td>
        <td>{{user.nome}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
  // import Mask from './Mask.js'
  export default {
    name: 'userlist',
    data () {
      return {
        loading: false,
        users: []
      }
    },
    methods: {
      load (params = '') {
        const url = './api/php/getuser.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            console.log(response.body)
            if (response.body.length > 0) {
              this.users = response.body
            } else {
              this.users = []
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      select4edit (cod) {
        this.$router.push({path: `/usuario/${cod}`})
      },
      select4agenda (cod) {
        this.$router.push({path: `/agenda/c/${cod}`})
      }
    },
    created: function () {
      this.load({'rel': 'all'})
    },
    watch: {
      '$route' (to, from) {
        this.load({'rel': 'all'})
      }
    }
  }
</script>

<style scoped>
    table {
      font: 12px sans-serif;
      color: #333;
      border-collapse: collapse;
      outline: 2px solid #333;
      text-align: left;
      width: 80vw;
    }
    table tr {
      background: #fcfcfc;
    }
    table tr:nth-child(2n+1) {
      background: #f1f1f1;
    }
    table tr:hover{
      background: #ccc;
    }
    table tr:first-child {
      background: #333;
      color: #fff;
      text-transform: uppercase;
    }
    table tr td {
      padding: 5px;
    }
    table tr td small {
      color: #777;
    }
    a.glyphicon {
      text-decoration: none;
    }
    .searchbox {
      margin: 10px 50px 10px 0;
    }
    div.use {
      display: inline;
    }
</style>


// WEBPACK FOOTER //
// src/components/UserRel.vue